/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class PXPMainDirectiveTransformer {
  async Transform(htmlStream : any) : Promise<any> {
    return await componentApi.call('pxp', 'pxp-main-content', 'PXPMainDirectiveTransformer', 'Transform', {
      htmlStream,
    });
  }
}
export default new PXPMainDirectiveTransformer()
